/** Web-safe env vars (Vite). Copy .env.example → .env.local */
export const env = {
  awsRegion: import.meta.env.VITE_AWS_REGION ?? 'ap-southeast-2',
  cognitoUserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID ?? '',
  cognitoClientId: import.meta.env.VITE_COGNITO_CLIENT_ID ?? '',
  cognitoDomain: import.meta.env.VITE_COGNITO_DOMAIN ?? '',
  appsyncGraphqlUrl: import.meta.env.VITE_APPSYNC_GRAPHQL_URL ?? '',
  chimeApiUrl: import.meta.env.VITE_CHIME_API_URL ?? '',
  /** GIPHY Web SDK / API key for the in-composer GIF picker. Empty disables GIF search. */
  giphyApiKey: import.meta.env.VITE_GIPHY_API_KEY ?? '',
  /** Native FCM/APNs — requires google-services.json and a rebuild. Off by default. */
  enablePush: import.meta.env.VITE_ENABLE_PUSH === 'true',
  /**
   * VAPID application-server PUBLIC key (base64url) for browser Web Push. Safe to
   * ship to the client; the matching PRIVATE key is a Lambda secret only. Empty
   * disables closed-tab web push subscription (the app still works otherwise).
   */
  vapidPublicKey: import.meta.env.VITE_VAPID_PUBLIC_KEY ?? '',
  /**
   * Canonical public app origin used to build shareable deep links (e.g. the
   * Jobs "I'd be interested" DM prefill). Must NOT use `window.location.origin`
   * — on native/Capacitor that resolves to `https://localhost`, producing an
   * untappable link. Defaults to the production custom domain.
   */
  publicAppUrl: (import.meta.env.VITE_PUBLIC_APP_URL ?? 'https://ascendmessenger.com.au').replace(
    /\/$/,
    '',
  ),
  /**
   * Last-resort HTTPS Play listing if the native `market://` opener fails.
   * Do not point this at the internal-test *join* URL — that is an opt-in page
   * (Google login), not an update. Testers already opted in should land on the
   * Play Store app listing for this package.
   */
  androidPlayUpdateUrl: (
    import.meta.env.VITE_ANDROID_PLAY_UPDATE_URL ??
    'https://play.google.com/store/apps/details?id=com.ascendhealth.comms'
  ).replace(/\/$/, ''),
  /**
   * Optional baked Android versionCode used when Play In-App Updates does not
   * report an update (typical on internal testing) AND fetching
   * android-latest.json fails. Prefer updating `frontend/public/android-latest.json`
   * (deployed with the web app) so installed binaries can see newer store
   * versions without a rebuild.
   */
  androidLatestVersionCode: import.meta.env.VITE_ANDROID_LATEST_VERSION_CODE ?? '',
  /** Override the published version JSON URL. Empty → `{publicAppUrl}/android-latest.json`. */
  androidLatestVersionUrl: (import.meta.env.VITE_ANDROID_LATEST_VERSION_URL ?? '').replace(
    /\/$/,
    '',
  ),
} as const
